import BaseRepo from "./Repository";

const resource = "/login";

export default {
  /**
   * Perform login with API.
   * Expects a JWT
   * @param {Object} payload User credentials
   */
  async login(payload) {
    try {
      return await BaseRepo.post(resource, payload);
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get connected user info
   */
  async me() {
    try {
      return await BaseRepo.get("/me");
    } catch (error) {
      throw error;
    }
  }
};
